import React, { Fragment, PureComponent } from 'react';
import { Table, Modal, Tooltip } from 'antd';
import moment from 'moment';

function InfectedFilesModal({ isOpen, closeModal, record, signatureName }) {
  const [data, setData] = React.useState([]);
  const columns = [
    {
      key: 'index',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'File Path',
      dataIndex: 'filePath',
      width: '50%',
      render: text => (
        <Tooltip overlayStyle={{ maxWidth: 'max-content' }} title={text}>
          <div style={{ color: 'red' }}>
            {text?.length > 45 ? `${text.substring(0, 45)} ...` : text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Size',
      dataIndex: 'size',
      render: text => `${text} KB`,
      width: '20%',
      sorter: (a, b) => parseFloat(a.size) - parseFloat(b.size),
    },
    {
      title: 'Date Modified',
      sorter: (a, b) => moment(a.date) - moment(b.date),
      width: '20%',
      render: text => moment(text).format('ll'),
      dataIndex: 'lastModified',
    },
  ];

  const getInfectedFiles = () => {
    if (record && signatureName) {
      setData(record[0]?.cloudXRayRisks?.malwares[signatureName]?.filesInfected);
    }
  };
  React.useEffect(() => {
    getInfectedFiles();
  });
  return (
    <Modal
      title="Infected Files"
      visible={isOpen}
      center
      footer={null}
      onCancel={() => closeModal()}
      width={1000}
    >
      <Table
        columns={columns}
        pagination={false}
        dataSource={data}
        size="small"
        scroll={{ y: 300 }}
      />
    </Modal>
  );
}

export default InfectedFilesModal;
